import React, {Component} from 'react';
import './title.css'
class Title extends Component {
    render() {
        return (
            <div>
                <h1>Le Domaine des Lacs de Weiswampach</h1>
            </div>
        );
    }
}

export default Title;